/**
 * Sprava session-id (identifikator relace aktualni diskuze). Identifikator se
 * generuje na klientovi, uklada se do localstorage. Posila se ke kazdemu requestu
 * a pokud se klikne na obnovit, tak se vygeneruje novy.
 */
import React, { createContext, useContext, useState } from 'react';

interface IStore {
    store: {
        disableTextInput?: boolean
        disableSendButton?: boolean
        disableRenewButton?: boolean
        disableFAQ?: boolean
        qestionInput?: string
    }
    setStore: (store: IStore['store']) => void
}

export type StoreType = IStore;

export const StoreContext = createContext<StoreType>({ store: {}, setStore: () => { } });

export const useStore = () => {
    return useContext(StoreContext);
};

interface IStoreProps {
    children: any
}

function Store({ children }: IStoreProps) {
    const [store, setStore] = useState<IStore['store']>({});

    return (
        <StoreContext.Provider value={{ store, setStore }}>
            {children}
        </StoreContext.Provider>
    );
}

export default Store;
